import { useMutation } from 'react-query';
import { toastr } from 'react-redux-toastr';
import useIntl from 'hooks/useIntl';
import useSelectedProperty from 'hooks/useSelectedProperty';
import RentForecastService from 'services/rentForecastService';
import messages from './messages';
import rentForecastMessages from '../messages';
import type { DeleteMutationOptions, DeleteMutationHTTPError } from './types';

export const useDeleteForecastMutation = ({
  close,
  onSuccess,
}: DeleteMutationOptions) => {
  const intl = useIntl();

  const { organizationId, id: propertyId } = useSelectedProperty();

  return useMutation(
    ({ rentForecastId }) =>
      new RentForecastService().deleteRentForecast(
        organizationId,
        propertyId,
        rentForecastId,
      ),
    {
      onSuccess: (_result, { rentForecastName }) => {
        toastr.success(
          intl.formatMessage(rentForecastMessages.success),
          intl.formatMessage(messages.resultSuccess, {
            forecastName: rentForecastName,
          }),
        );

        close();
        onSuccess();
      },
      onError: (error: DeleteMutationHTTPError) => {
        let errorMessage;

        switch (error.statusCode) {
          case 403:
            errorMessage = intl.formatMessage(messages.resultNoPermission);
            break;
          case 409:
            errorMessage = intl.formatMessage(messages.resultConflict, {
              conflict:
                error.message ??
                'Unknown error occurred, please try again later.',
            });
            break;
          default:
            errorMessage = intl.formatMessage(messages.resultFail);
            break;
        }

        toastr.error(
          intl.formatMessage(rentForecastMessages.error),
          errorMessage,
          {
            timeOut: 0,
            showCloseButton: true,
          },
        );
      },
    },
  );
};
